// src/Header.js
import React from 'react';
import Logo from './assets/logo.png';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = ({ scrollToSection, activeSection }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSectionClick = (sectionId) => {
    if (scrollToSection) {
      scrollToSection(sectionId);
    } else {
      localStorage.setItem('scrollToSection', sectionId);
      if (location.pathname !== '/') {
        navigate('/');
      }
    }
  };

  return (
    <nav
      style={{
        backgroundColor: 'white',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}
    >
      <div
        style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 1rem' }}
        className="flex justify-between items-center h-16"
      >
        <div
          className="flex items-center cursor-pointer"
          onClick={() => navigate('/')}
        >
          <img
            src={Logo}
            alt="Wentago Logo"
            className="w-12 h-12 object-contain mr-2"
          />
          <h1 className="text-2xl font-bold text-[rgb(0,131,234)]">Wentago</h1>
        </div>

        <div className="flex gap-4">
          <button
            onClick={() => handleSectionClick('about')}
            style={{
              padding: '0.5rem 0.75rem',
              borderRadius: '6px',
              fontSize: '0.875rem',
              fontWeight: '500',
              backgroundColor:
                activeSection === 'about' ? 'rgba(0,131,234,0.1)' : 'transparent',
              color: activeSection === 'about' ? 'rgb(0,131,234)' : '#4B5563',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            About
          </button>
          <button
            onClick={() => handleSectionClick('products')}
            style={{
              padding: '0.5rem 0.75rem',
              borderRadius: '6px',
              fontSize: '0.875rem',
              fontWeight: '500',
              backgroundColor:
                activeSection === 'products' ? 'rgba(0,131,234,0.1)' : 'transparent',
              color: activeSection === 'products' ? 'rgb(0,131,234)' : '#4B5563',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Products
          </button>
          <button
            onClick={() => handleSectionClick('pricing')}
            style={{
              padding: '0.5rem 0.75rem',
              borderRadius: '6px',
              fontSize: '0.875rem',
              fontWeight: '500',
              backgroundColor:
                activeSection === 'pricing' ? 'rgba(0,131,234,0.1)' : 'transparent',
              color: activeSection === 'pricing' ? 'rgb(0,131,234)' : '#4B5563',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Pricing
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Header;
